export const getImageUrl = (fileName: string) => {
    return `${process.env.PUBLIC_URL}/${fileName}`
}
